import {
    commonGetData,
    createExceptionRes,
    createResFromResponse,
} from "./common";

const BASE_API = () => {
    try {
        return `${window.location.protocol}//${window.location.host}`;
    } catch {
        return process.env.NEXT_PUBLIC_SITE_URL ?? "";
    }
};

const API_GET_FIREBASE_CONFIG = () => `${BASE_API()}/api/firebase`;

// withCredential=false: la config Firebase serve PRIMA di avere il token

export const getFirebaseConfig = async () => {
    try {
        const res = await commonGetData(false, {}, API_GET_FIREBASE_CONFIG());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return await createResFromResponse<any>(res);
    } catch (e) {
        return createExceptionRes(e);
    }
};
